import { Component } from '@angular/core';

@Component({
  selector: 'app-emptyaddresses',
  templateUrl: './emptyaddresses.component.html',
  styleUrl: './emptyaddresses.component.scss'
})
export class EmptyaddressesComponent {

}
